import moment from 'moment-timezone';

let session = {
  expiresAt: null,
  willRefresh: null,
  nextRefresh: null,
  timedOut: false,
  loggedOut: false,
};
let xmSessionChannel;

window.getSession = () => session;

export const getSession = () => session;
export const getExpiresAt = () => moment(session.expiresAt);
export const getWillRefresh = () => session.willRefresh;
export const getNextRefresh = () => moment(session.nextRefresh);
export const isTimedOut = () => session.timedOut;
export const isLoggedOut = () => session.loggedOut;

export const mergeToSession = val => {
  session = { ...session, ...val };
};
export const updateSession = val => {
  mergeToSession(val);
  xmSessionChannel?.postMessage?.(val);
};

export const setSessionChannel = sessionChannel => {
  xmSessionChannel = sessionChannel;
};
export const getSessionChannel = () => xmSessionChannel;
